import CustomAmplitudeClient from "./custom-amplitude-client.b75422c9d833.js";

class SearchResultCard extends HTMLElement {
  constructor() {
    super();
    this.config = JSON.parse(
      document.getElementById("page-config").textContent,
    );
    if (!this.config) throw new Error("unable to load page config");
    this.amplitudeClient = new CustomAmplitudeClient(this.config.analyticsUrl);
  }

  connectedCallback() {
    this.cardId = this.getAttribute("card-id");
    this.cardContainer = document.getElementById(this.cardId);
    this.bindListeners();
  }

  bindListeners() {
    this.cardContainer.querySelectorAll("tqc-tooltip").forEach((tooltip) => {
      tooltip.addEventListener("click", (evt) => {
        // Prevent click event from propagating to the card
        // This prevents the user from going to the cost breakdown page
        // since this.cardContainer is a link with an href to that page.

        // Clicking on a tooltip should never navigate the user away,
        // because the tooltip has one function, which is to show more information about the current page
        evt.preventDefault();
      });
    });
    const careQualityButton =
      this.cardContainer.querySelector("#tqc-care-quality");
    if (careQualityButton) {
      careQualityButton.addEventListener("click", (evt) => {
        // Prevent click event from propagating to the card
        // This prevents the user from going to the cost breakdown page
        // since this.cardContainer is a link with an href to that page
        evt.preventDefault();
      });
    }
  }
}
window.customElements.define("search-result-card", SearchResultCard);
